import React, { useContext, useEffect } from 'react'
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import DatePicker from "react-date-picker";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import { ERROR_MESSAGES } from '../../Components/GlobalErrorMessage';
import { FestivalIdolBooking } from '../../ApiServices/GanapatiVisarjan/GanapatiVisarjanApi';
import { data, useNavigate } from 'react-router-dom';
import { handleProceedRemainingPayment } from '../../Components/RazorPay/RazorPayFunction';
import { LoaderContext } from '../../AuthContext/AuthContext';
import axios from 'axios';
import { BaseUrl } from '../../BaseUrl/BaseUrl';
import dayjs from 'dayjs';

const VisarjanFormModal = ({ show, onHide, selectedPackage, totalAmount }) => {
    const { setLoader } = useContext(LoaderContext);
    const userID = localStorage.getItem("userID");
    const navigate = useNavigate()
    const [selectedPackages, setSelectedPackages] = useState("")
    const [error, setError] = useState(false)
    const [formObj, setFormObj] = useState({
        customerName: null,
        mobileNo: null,
        address: null,
        date: null,
        time: null,

    })

    useEffect(() => {
        if (show) {
            const packageString = selectedPackage.join(",");
            setSelectedPackages(packageString)
        }
    }, [show])

    const HandleSubmit = () => {

        let isValid = true

        if (formObj?.customerName === null || formObj?.customerName === undefined || formObj?.customerName === "" ||
            formObj?.mobileNo === null || formObj?.mobileNo === undefined || formObj?.mobileNo === "" || formObj?.mobileNo?.length !== 10 ||
            formObj?.address === null || formObj?.address === undefined || formObj?.address === "" ||
            formObj?.date === null || formObj?.date === undefined || formObj?.date === "" ||
            formObj?.time === null || formObj?.time === undefined || formObj?.time === ""
        ) {
            setError(true)
            isValid = false
        }

        const apiParam = {
            CustomerName: formObj?.customerName,
            MobileNo: formObj?.mobileNo,
            Address: formObj?.address,
            Date: formObj?.date,
            Time: formObj?.time,
            FestIdolBookTypeID: 2,
            FIB_ServiceIDs: selectedPackage,
            Price: totalAmount,
            USER_ID: 20243,
            PaidAmount: totalAmount,
            PaymentType: 'Online',
            TransactionID: null,
            ApplicationType: "webapp"
        }

        if (isValid) {
            // FestivalIdolBookingData(apiParam)
            handleRazorpayPayment()
        }
    }


    const handleRazorpayPayment = async () => {

        let orderIDReturned = null
        let minPayableAmount = Math.round(totalAmount);
        setLoader(true)
        const PlaceOrderResponse = await handleProceedRemainingPayment(minPayableAmount)
        console.log('PlaceOrderResponse', PlaceOrderResponse)
        setLoader(true)
        if (PlaceOrderResponse?.status === 1) {

            axios
                .post(`${BaseUrl}/FestivalIdolBooking`, {
                    CustomerName: formObj?.customerName,
                    MobileNo: formObj?.mobileNo,
                    Address: formObj?.address,
                    Date: formObj?.date,
                    Time: formObj?.time,
                    FestIdolBookTypeID: 2,
                    FIB_ServiceIDs: selectedPackages,
                    Price: totalAmount,
                    USER_ID: userID,
                    PaidAmount: totalAmount,
                    PaymentType: 'Online',
                    TransactionID: PlaceOrderResponse?.razorpay_payment_id,
                    ApplicationType: "webapp"
                })
                .then((res) => {
                    if (res) {
                        console.log(res);
                        // setOrderID(res.data.ID);
                        orderIDReturned = res.data.ID;
                        setLoader(false)
                        navigate("/thank-you", {
                            state: { moduleName: "GanapatiVisarjan" },
                        });
                    }
                });
        } else if (PlaceOrderResponse?.status === 0) {
            setLoader(false)
            alert('Order Failed !')
        }
    };


    const FestivalIdolBookingData = async (apiParam) => {

        setLoader(true);
        try {
            const response = await FestivalIdolBooking(apiParam);

            if (response?.ResponseCode === '0') {
                setLoader(false);
                const list = response?.DATA || [];


            }

        } catch (error) {
            setLoader(false);
            console.log(error);
        }
    };

    const handleToDateChange = (newValue) => {

        if (dayjs(newValue).isValid()) {
            const newToDate = dayjs(newValue).format("YYYY-MM-DD");
            setFormObj((prev) => ({ ...prev, date: newToDate }));
        } else {
            setFormObj((prev) => ({ ...prev, date: null }));
        }
    };

    const ClearObject = () => {
        setFormObj(((PREV) => ({
            ...PREV, customerName: null,
            mobileNo: null,
            address: null,
            date: null,
            time: null,
        })))
    }
    const HandleClose = () => {
        setError(false)
        ClearObject()
        onHide()
    }
    return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title className="w-100 text-center">
                        <span style={{ fontSize: "20px", fontWeight: "400" }}>
                            Ganapati Visarjan Booking Form
                        </span>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body >
                    <div className="px-3" >
                        <div className="row " style={{ textAlign: 'left' }}>
                            {/* Date Picker */}
                            <div className="col-md-6 d-flex flex-column">
                                <label className="form-label fw-light labelFontSize text-start">
                                    Booking Date <span className="text-danger">*</span>
                                </label>
                                <DatePicker
                                    id="bookingDate"
                                    value={formObj?.date || ""}
                                    clearIcon={null}
                                    onChange={handleToDateChange}
                                    format="dd/MM/yyyy"
                                    className="custom-date-picker"
                                />
                                {(error && (!formObj.date || formObj.date === "")) && (
                                    <span className="error-msg">This field is required</span>
                                )}
                            </div>

                            {/* Time Picker */}
                            <div className="col-md-6 d-flex flex-column">
                                <label className="form-label fw-light labelFontSize text-start">
                                    Booking Time <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="time"
                                    className="custom-form-control rounded-3"
                                    value={formObj.time || ""}
                                    onChange={(e) =>
                                        setFormObj((prev) => ({
                                            ...prev,
                                            time: e.target.value,
                                        }))
                                    }
                                />
                                {(error && (!formObj.time || formObj.time === "")) && (
                                    <span className="error-msg">This field is required</span>
                                )}
                            </div>
                        </div>

                        {/* Mobile Number + Full Name (2 in one row for desktop, stacked on mobile) */}
                        <div className="row  mt-2" style={{ textAlign: 'left' }}>
                            <div className="col-md-6 d-flex flex-column">
                                <label className="form-label fw-light labelFontSize text-start">
                                    Mobile Number <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="custom-form-control rounded-3"
                                    maxLength={10}
                                    placeholder="Enter Mobile Number"
                                    value={formObj.mobileNo}
                                    onChange={(e) => {

                                        let formattedNumber = e.target.value.replace(/[^0-9]/g, "");
                                        formattedNumber = formattedNumber.replace(/^[0-5]/, "");
                                        setFormObj((prev) => ({
                                            ...prev,
                                            mobileNo: formattedNumber,
                                        }));
                                    }}
                                />
                                {(error && (!formObj.mobileNo || formObj.mobileNo === "")) ? (
                                    <span className="error-msg">{ERROR_MESSAGES}</span>
                                ) : (error && (formObj.mobileNo?.length !== 10) ? <span className="error-msg">Invalid Mobile Number</span> : '')}
                            </div>

                            <div className="col-md-6 d-flex flex-column">
                                <label className="form-label fw-light labelFontSize text-start">
                                    Full Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className="custom-form-control rounded-3"
                                    placeholder="Enter Full Name"
                                    value={formObj.customerName}
                                    onChange={(e) => {
                                        let inputVal = e.target.value;
                                        if (inputVal.startsWith(" ")) {
                                            inputVal = inputVal.trimStart();
                                        }
                                        setFormObj((obj) => ({
                                            ...obj,
                                            customerName: inputVal,
                                        }));
                                    }}
                                />
                                {(error && (!formObj.customerName || formObj.customerName === "")) && (
                                    <span className="error-msg">{ERROR_MESSAGES}</span>
                                )}
                            </div>
                        </div>

                        {/* Address */}
                        <div className="row  mt-2" style={{ textAlign: 'left' }}>
                            <div className="col-12 d-flex flex-column">
                                <label className="form-label fw-light labelFontSize text-start">
                                    Address <span className="text-danger">*</span>
                                </label>
                                <textarea
                                    className="custom-form-control rounded-3"
                                    maxLength={200}
                                    placeholder="Enter Address"
                                    value={formObj.address}
                                    onChange={(e) => {
                                        setError(false);
                                        let inputVal = e.target.value;
                                        if (inputVal.startsWith(" ")) {
                                            inputVal = inputVal.trimStart();
                                        }
                                        setFormObj((prev) => ({
                                            ...prev,
                                            address: inputVal,
                                        }));
                                    }}
                                />
                                {(error && (!formObj.address || formObj.address === "")) && (
                                    <span className="error-msg">This field is required</span>
                                )}
                            </div>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer >
                    <Button
                        variant="secondary"
                        onClick={HandleClose}
                        style={{
                            color: "white",
                            padding: "10px 15px",
                            cursor: 'pointer'
                            , fontSize: '14px',
                            fontWeight: 'bold'
                        }}
                    >
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={HandleSubmit}
                        style={{
                            backgroundColor: "#a52444",
                            color: "#2B1B10",
                            border: "none",
                            color: "white",
                            padding: "10px 15px",
                            cursor: 'pointer'
                            , fontSize: '14px',
                            fontWeight: 'bold'
                        }}
                    >
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal >
        </>
    )
}

export default VisarjanFormModal
